import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-661d6d80"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "about-container" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "intro" }, "四川润泽皓宇科技有限公司，是专注于防灾减灾救灾和安全保障事业的高新技术企业。公司集研发、生产、销售、集成和服务于一体，基于计算机应用、现代通讯、大数据挖掘、人工智能等技术，提供智慧化的新一代整体解决方案和链接全流程的优质服务。 瞄准行业前沿，立足自主创新和系统集成的融合，公司组建起深耕行业领域的技术团队，联合各大高校平台、相关科研院所加速技术创新、成果转化、人才培养和团队建设进程，以成果、产品和整体解决方案的优化更新，满足客户的更高需求。 经过持续的技术开发和成果转化积累，公司打造形成覆盖森林草原防灭火指挥系统、应急综合指挥系统、安全生产管控系统、多业务融合指挥调度系统、穿戴式生命体征感知系统、卫星通讯网络管理系统、无线电短波和微波通信系统等领域的成熟产品与系统解决方案。 公司整合优势资源而成的“软件+硬件”两大系列数十款产品，着力于引领分析决策、指挥调度、安全保障业务，广泛应用于应急、消防、自然资源、人防、公安系统的各个关键节点，为推动防灾减灾救灾技术持续进步，贡献全部的智慧和力量。", -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BannerClassify = _resolveComponent("BannerClassify")!
  const _component_CompanyInfo = _resolveComponent("CompanyInfo")!
  const _component_WorkEnvironment = _resolveComponent("WorkEnvironment")!
  const _component_RecruitInfo = _resolveComponent("RecruitInfo")!
  const _component_MyPagination = _resolveComponent("MyPagination")!
  const _component_FooterInfo = _resolveComponent("FooterInfo")!
  const _component_CopyrightInfo = _resolveComponent("CopyrightInfo")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_BannerClassify, {
      style: {"margin-top":"90px"},
      type: "3",
      bannerUrl: _ctx.state.bannerUrl,
      activeCode: _ctx.state.activeCode,
      classifyList: _ctx.state.classifyList,
      onOnChangeActiveCode: _ctx.changeActiveCode
    }, null, 8, ["bannerUrl", "activeCode", "classifyList", "onOnChangeActiveCode"]),
    (_ctx.state.activeCode === '0')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : _createCommentVNode("", true),
    (_ctx.state.activeCode === '1')
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(_component_CompanyInfo),
          _createVNode(_component_WorkEnvironment)
        ]))
      : _createCommentVNode("", true),
    (_ctx.state.activeCode === '2')
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createVNode(_component_RecruitInfo, {
            list: _ctx.state.list,
            onOnSwitchStatus: _ctx.switchStatus
          }, null, 8, ["list", "onOnSwitchStatus"]),
          _createVNode(_component_MyPagination, {
            currentPage: _ctx.state.page.current,
            totalCount: _ctx.state.arr.length,
            onOnChangePagination: _ctx.changePage
          }, null, 8, ["currentPage", "totalCount", "onOnChangePagination"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_FooterInfo),
    _createVNode(_component_CopyrightInfo)
  ]))
}